import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import RoomPage from './pages/RoomPage';
import EmbedPage from './pages/EmbedPage';
import AdminDashboard from './pages/AdminDashboard';
import AdminClientForm from './pages/AdminClientForm';
import AdminLogin from './pages/AdminLogin';
import Playground from './pages/Playground';
import { adminAuth } from './services/api';

function RequireAdmin({ children }) {
  const location = useLocation();
  if (!adminAuth.isAuthenticated()) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      {/* Sala de video */}
      <Route path="/sala/:roomId" element={<RoomPage />} />
      <Route path="/embed/:roomId" element={<EmbedPage />} />

      {/* Admin (protegido) */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
      <Route path="/admin/clients/:id" element={<RequireAdmin><AdminClientForm /></RequireAdmin>} />

      {/* API Playground (protegido) */}
      <Route path="/playground" element={<RequireAdmin><Playground /></RequireAdmin>} />

      {/* Home */}
      <Route path="*" element={
        <div className="min-h-screen flex items-center justify-center bg-gray-950 text-white">
          <div className="text-center">
            <div className="w-16 h-16 bg-indigo-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <span className="text-2xl">📹</span>
            </div>
            <h1 className="text-4xl font-bold mb-2">Help Video Call</h1>
            <p className="text-gray-400 mb-8">Plataforma de videochamada — self-hosted</p>
            <div className="flex gap-4 justify-center">
              <a href="/admin" className="px-6 py-3 bg-indigo-600 hover:bg-indigo-500 rounded-xl font-medium transition-colors">
                Painel Admin
              </a>
              <a href="/playground" className="px-6 py-3 bg-gray-800 hover:bg-gray-700 rounded-xl font-medium transition-colors">
                API Playground
              </a>
            </div>
          </div>
        </div>
      } />
    </Routes>
  </BrowserRouter>
);
